import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ROLE_ROUTE_ACCESS } from 'src/app/app.contant';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGaurdService implements CanActivate {

  constructor(
    private authService: AuthService,
    private _toastr : ToastrService,
    private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!this.authService.isAuthenticated()) {
        this.authService.clearAllStorage();
        if(environment.manualLogin){
          // this._toastr.error("Please login to continue! canActivate");
        }
        this.router.navigate(['/login']);
        return false;
      }
      const roleInfo = this.authService.getUserRole();
      
      if(state.url && roleInfo && ROLE_ROUTE_ACCESS[roleInfo]) {
        for (let index = 0; index < ROLE_ROUTE_ACCESS[roleInfo].length; index++) {
          if(state.url.includes(ROLE_ROUTE_ACCESS[roleInfo][index])) {
            return true
          }
        }
        this._toastr.error("You do not have access to this feature!");
        this.authService.routeRedirection(roleInfo);
        return false;
      }
      return true
  }

  canLoad(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // return this.authService.isLoggedIn.pipe(
    //   take(1),
    //   map((isLoggedIn: boolean) => {
    //     if (!isLoggedIn) {
    //       this.authService.clearAllStorage();
    //       this.router.navigate(['/login']);
    //       this._toastr.error("Please login to continue!");
    //       return false;
    //     }
    //     return true;
    //   })
    // );
    if(!this.authService.isAuthenticated() && environment.manualLogin) {
      this.authService.clearAllStorage();
      this.router.navigate(['/login']);
      // this._toastr.error("Please login to continue!");
      return false;
    }
    const roleInfo = this.authService.getUserRole();
    
    if(state.url && roleInfo && ROLE_ROUTE_ACCESS[roleInfo]) {
      for (let index = 0; index < ROLE_ROUTE_ACCESS[roleInfo].length; index++) {
        if(state.url.includes(ROLE_ROUTE_ACCESS[roleInfo][index])) {
          return true
        }
      }
      this._toastr.error("You do not have access to this feature!");
      this.authService.routeRedirection(roleInfo);
      return false;
    }
    return true
  }

}

